import React, { useEffect, useState } from "react";
import { Input } from "@/components/ui/input";
import { Badge } from "@/components/ui/badge";
import { Search } from "lucide-react";
import api from "@/lib/api";

export const AdminTraders = () => {
  const [traders, setTraders] = useState([]);
  const [q, setQ] = useState("");
  useEffect(() => { api.get("/admin/traders").then((r) => setTraders(r.data || [])); }, []);
  const filtered = traders.filter((t) => {
    const k = q.toLowerCase();
    return !k || t.email?.toLowerCase().includes(k) ||
      (t.first_name || "").toLowerCase().includes(k) ||
      (t.last_name || "").toLowerCase().includes(k);
  });
  return (
    <div className="space-y-6" data-testid="admin-traders-page">
      <div className="flex items-end justify-between flex-wrap gap-3">
        <div>
          <h1 className="font-display text-3xl font-bold">Traders</h1>
          <p className="text-[#8a8a8a] text-sm mt-1">{traders.length} registered traders</p>
        </div>
        <div className="relative w-full sm:w-80">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-[#8a8a8a]" size={16} />
          <Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search traders..." className="pl-9 bg-[#0a0a0a] border-[#ff7a00]/20 h-11" data-testid="traders-search" />
        </div>
      </div>
      <div className="glass rounded-xl overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="text-[10px] tracking-widest text-[#8a8a8a] uppercase border-b border-[#ff7a00]/15">
              <th className="text-left p-4">Email</th>
              <th className="text-left p-4">Name</th>
              <th className="text-left p-4">Country</th>
              <th className="text-left p-4">Role</th>
              <th className="text-left p-4">Status</th>
              <th className="text-left p-4">Joined</th>
            </tr>
          </thead>
          <tbody>
            {filtered.map((t) => (
              <tr key={t.id} className="border-b border-[#ff7a00]/5 hover:bg-white/2" data-testid={`trader-row-${t.id}`}>
                <td className="p-4 text-[#f5f5f5]">{t.email}</td>
                <td className="p-4 text-[#cfcfcf]">{t.first_name || ""} {t.last_name || ""}</td>
                <td className="p-4 text-[#8a8a8a]">{t.country || "—"}</td>
                <td className="p-4">
                  <div className="flex gap-1.5">
                    {(t.roles || []).map((r) => (
                      <Badge key={r} className={r === "admin" ? "bg-[#ff7a00]/15 text-[#ff7a00] border-[#ff7a00]/30 text-[10px] uppercase" : "bg-white/5 text-[#cfcfcf] border-white/10 text-[10px] uppercase"}>{r}</Badge>
                    ))}
                  </div>
                </td>
                <td className="p-4">
                  <Badge className={t.is_active ? "bg-emerald-500/15 text-emerald-400 border-emerald-500/30 text-[10px] uppercase" : "bg-red-500/15 text-red-400 border-red-500/30 text-[10px] uppercase"}>
                    {t.is_active ? "Active" : "Inactive"}
                  </Badge>
                </td>
                <td className="p-4 text-[#8a8a8a]">{t.created_at ? new Date(t.created_at).toLocaleDateString() : "—"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
